export default {
	acceptTermsMiddle: "et la",
	acceptTermsPrefix: "J'ai lu et j'accepte les",
	alreadyHaveAccount: "Vous avez déjà un compte ?",
	joinAsMember: "Rejoindre en tant que membre",
	joinAsMemberDesc: "J'ai été invité(e) par un temple à rejoindre l'équipe",
	viewPlans: "Voir les forfaits et tarifs",
	viewPlansDesc: "Composez votre forfait — base plus les options souhaitées — et voyez le prix",
	login: "Se connecter",
	privacyPolicy: "Politique de confidentialité",
	registerTemple: "Enregistrer mon Temple",
	registerTempleDesc: "Je suis un dirigeant ou administrateur d'un temple et je souhaite l'enregistrer dans le système",
	subtitle: "Choisissez comment vous souhaitez commencer",
	termsOfUse: "Conditions d'utilisation",
	termsRequired: "Vous devez accepter les conditions pour continuer",
	welcome: "Bienvenue sur ORI",
};
